// Portuguese translation
import { pt as views_pt } from "./views";

const pt = {
  "app.global.spanish": "Espanhol",
  "app.global.english": "Inglês",
  "login.welcome": "Bem-vindo!",
  "login.start_session": "INICIAR SESSÃO",
  "login.invalid_user_password": "Usuário ou senha inválidos!",
  "login.button_enter": "ENTRAR",
  "login.password": "SENHA",
  "login.database": "BANCO DE DADOS",
  "login.username": "USUÁRIO",
  "login.forgot_password": "Esqueceu a senha?",
  "board.loading_please_wait": "Carregando... Por favor, aguarde!",
  "board.loading": "Carregando...",
  "board.approve": "APROVAR",
  "board.button_edit": "EDITAR",
  button_edit: "Editar",
  "board.button_add": "ADICIONAR",
  button_add: "Adicionar",
  "board.button_back": "VOLTAR",
  "board.button_save": "SALVAR",
  "board.button_remove": "REMOVER",
  "board.button_replace": "SUBSTITUIR",
  "board.filter": "FILTRAR",
  "board.button_confirm": "CONFIRMAR",
  "board.chart.in_thousands": "Em milhares",
  "board.chart.see_report": "Ver relatório",
  "board.sheet_select": "Planilha",
  "board.missing_required_fields": "Campos obrigatórios ausentes!",
  "quicktable.select_all": "TODOS",
  missing_required_fields: "Campos obrigatórios ausentes!",
  "board.records_found": "Registros encontrados",
  "board.records_saved": "REGISTROS SALVOS!",
  "board.record_created": "REGISTRO CRIADO!",
  "board.dialog.button_discard": "Descartar",
  "basic_modal.button_cancel": "CANCELAR",
  "basic_modal.button_ok": "OK",
  "basic_modal.button_accept": "Aceitar",
  "basic_modal.button_close": "Fechar",
  "basic_modal.button_create": "Criar",
  available: "Disponível",
  not_available: "Indisponível",
  select_time: "Selecione o horário...",
  "form_cloud_image.add_photo": "Adicionar imagem",
  "menu.dashboard": "DASHBOARD",
  "menu.dashboard_melhous": "MELHOUS",
  "menu.delivery": "ENTREGAS",
  "menu.order": "PEDIDOS",
  "menu.sale_order": "PEDIDO DE VENDA",
  "menu.housekeeping": "AMA DE CHAVES",
  "menu.rest_order": "PEDIDO REST.",
  "menu.travel_person": "PESSOA EM VIAGEM",
  "menu.ticket": "TURNO",
  "menu.affiliates": "AFILIADOS",
  "menu.assistant_control": "CONTROLE DE ACESSO",
  "menu.sale_call_center": "REGISTRO DE PEDIDOS",
  "sale.sale.number": "NÚMERO",
  "sale.sale.sale_date": "DATA",
  "sale.sale.consumer": "CONSUMIDOR",
  "sale.sale.position": "CARGO",
  "sale.sale.channel": "CANAL",
  "sale.sale.delivery_state": "STATUS",
  "sale.sale.comment": "COMENTÁRIO",
  "sale.sale.party": "PARTE",
  "sale.sale.waiting_time": "TEMPO DE ESPERA",
  "sale.sale.order_status": "STATUS",
  "sale.sale.commanded": "COMANDADO",
  "sale.sale.draft": "RASCUNHO",
  "sale.sale.billing": "FATURAMENTO",
  "sale.sale.invoice_number": "Número da Fatura",
  "sale.sale.pay": "PAGAR",
  "sale.sale.dispatched": "DESPACHADO",
  "sale.sale.rejected": "REJEITADO",
  "sale.sale.delivered": "ENTREGUE",
  "sale.sale.processing": "EM PROCESSO",
  "sale.sale.terminal": "TERMINAL",
  "sale.sale.gateway": "PORTAL",
  "sale.sale.total_amount": "TOTAL",
  "sale.sale.source": "ORIGEM",
  "sale.sale.description": "DESCRIÇÃO",
  "sale.sale.state": "ESTADO",
  "sale.sale.payment_method": "PAGAMENTO",
  "sale.sale.cash": "DINHEIRO",
  "sale.sale.persons": "Pessoas",
  "sale.sale.shipping_date": "Data de envio",
  "sale.line.product": "PRODUTO",
  "sale.line.quantity": "QTD",
  "sale.line.discount": "DESCONTO",
  "sale.line.unit_price": "PREÇO UNITÁRIO",
  "sale.line.unit": "UNIDADE",
  "sale.line.unit_price_w_tax": "PREÇO UNITÁRIO",
  "sale.line.sale_price_taxed": "PREÇO UNITÁRIO C/ IMPOSTO",
  "sale.line.amount": "VALOR",
  "sale.line.button_tag": "Etiquetas",
  "sale.sale.quote": "CONFIRMAR",
  "sale.sale.salesman": "VENDEDOR",
  "sale.sale.shipment_address": "END. ENVIO",
  "sale.sale.agent": "AGENTE",
  "sale.sale": "VENDA",
  "sale.line": "PRODUTOS",
  button_cancel: "CANCELAR",
  successful_order: "PEDIDO REALIZADO COM SUCESSO!",
  "sale.sale.price_list": "LISTA DE PREÇOS",
  button_delete: "EXCLUIR",
  "sale.sale.shipment_date": "DATA ENVIO",
  "sale.sale.today": "HOJE",
  "menu.stock_request": "SOLICITAÇÃO DE ESTOQUE",
  "menu.inventory": "INVENTÁRIO",
  "stock.inventory": "INVENTÁRIO",
  "stock.inventory.line": "LINHAS",
  "menu.purchase_requisition": "REQUISIÇÃO",
  "stock.shipment.internal": "SOLICITAÇÃO INTERNA",
  "stock.shipment.internal.reference ": "REFERÊNCIA",
  "stock.shipment.internal.from_location": "DE LOCAL",
  "stock.shipment.internal.to_location": "PARA LOCAL",
  "stock.shipment.internal.requested_by": "SOLICITADO POR",
  "stock.shipment.internal.moves": "PRODUTOS",
  "stock.shipment.internal.state": "ESTADO",
  "stock.shipment.internal.number": "NÚMERO",
  "stock.shipment.internal.effective_date": "DATA EFETIVA",
  "stock.shipment.internal.today": "HOJE",
  "stock.shipment.internal.wait": "CONFIRMAR",
  "stock.shipment.internal.planned_start_date": "Data de envio planejada",
  "stock.shipment.internal.print": "Imprimir",
  effective_date: "DATA PLANEJADA",
  uom: "UoM",
  default_uom: "UoM",
  "stock.move": "PRODUTOS",
  "stock.move.product": "PRODUTO",
  "stock.move.uom": "UoM",
  "stock.move.quantity": "QUANTIDADE",
  waiting: "AGUARDANDO",
  request: "SOLICITAÇÃO",
  billing: "FATURAMENTO",
  print: "IMPRIMIR",
  user_has_not_access_permissions: "Usuário sem permissão de acesso!",
  "purchase.purchase.purchase_date": "DATA",
  "purchase.purchase.number": "NÚMERO",
  "purchase.purchase.approved": "APROVADO",
  "purchase.purchase.confirmed": "CONFIRMADO",
  "purchase.purchase.done": "CONCLUÍDO",
  "purchase.purchase.processing": "EM PROCESSO",
  "purchase.purchase.cancelled": "CANCELADO",
  "purchase.purchase.total_amount": "VALOR TOTAL",
  "purchase.purchase.party": "PARTE",
  "purchase.purchase.state": "ESTADO",
  "purchase.purchase.project": "PROJETO",
  "purchase.purchase.create_uid": "USUÁRIO",
  "purchase.purchase.description": "DESCRIÇÃO",
  "purchase.purchase.payment_term": "TERMO DE PAGAMENTO",
  "purchase.purchase.reference": "REFERÊNCIA",
  "purchase.purchase.untaxed_amount": "VALOR SEM IMPOSTO",
  "purchase.purchase.tax_amount": "VALOR DO IMPOSTO",
  "purchase.purchase.comment": "COMENTÁRIO",
  "purchase.purchase.today": "HOJE",
  "purchase.purchase": "COMPRA",
  "purchase.purchase.pending": "PENDENTE",
  "purchase.purchase.all": "TODOS",
  "purchase.purchase.quotation": "COTAÇÃO",
  "purchase.purchase.draft": "RASCUNHO",
  "menu.purchase": "COMPRA",
  "menu.purchase_approval": "APROVAÇÃO DE COMPRA",
  "menu.shipment_internal": "ENVIO INTERNO",
  "purchase.line": "PRODUTOS",
  "product.code": "CÓDIGO",
  "product.description": "DESCRIÇÃO",
  "menu.surveillance_schedule": "Vigilância",
  "surveillance.schedule": "Vigilância",
  supplier: "FORNECEDOR",
  code: "CÓDIGO",
  employee: "FUNCIONÁRIO",
  active: "ATIVO",
  city: "CIDADE",
  name: "NOME",
  position: "CARGO",
  "board.button_reload": "RECARREGAR",
  successful: "TRANSAÇÃO REALIZADA COM SUCESSO!",
  total_amount_cache: "VALOR TOTAL",
  untaxed_amount_cache: "SUBTOTAL",
  tax_amount_cache: "IMPOSTOS",
  high: "Alta",
  urgent: "Urgente",
  low: "Baixa",
  "purchase.purchase.priority": "PRIORIDADE",
  "purchase.purchase.approval": "APROVAÇÃO",
  "purchase.purchase.approval_user": "APROVADO POR",
  "purchase.purchase.approval_date": "DATA DE APROVAÇÃO",
  "purchase.purchase.approval_signature": "APROVADO POR",
  "purchase.purchase.authorize": "AUTORIZAR",
  "purchase.purchase.authorized_user": "USUÁRIO AUTORIZADO",
  "purchase.purchase.authorized_signature": "AUTORIZADO POR",
  "purchase.purchase.confirm": "CONFIRMAR",
  "purchase.purchase.confirmation_signature": "CONFIRMADO POR",
  "purchase.purchase.confirm_user": "CONFIRMADO POR",
  "purchase.line.product": "PRODUTO",
  "purchase.line.unit_price": "PREÇO UNITÁRIO",
  "purchase.line.amount": "VALOR",
  "purchase.line.quantity": "QUANTIDADE",
  "purchase.line.description": "DESCRIÇÃO",
  "menu.hotel_planner": "PLANEJADOR",
  "menu.hotel_calendar": "CALENDÁRIO",
  "menu.hotel_rack": "RACK",
  "menu.take_order": "REGISTRO DE PEDIDO",
  "menu.order_viewer": "VISUALIZADOR DE PEDIDOS",
  table_assigned: "MESA",
  command: "COMANDAR",
  note: "NOTA",
  order_sended: "Pedido enviado",
  "sale.line.note": "Notas",
  "sale.line.requested": "Solicitado",
  "sale.line.draft": "Rascunho",
  "sale.line.commanded": "Comandado",
  "room.none": "Nenhum",
  "room.blocked": "Bloqueado",
  "room.check_in": "Check-In",
  "room.check_out": "Check-Out",
  "room.maintenance": "Manutenção",
  "room.pending": "Pendente",
  "menu.self_service_sale": "AUTO VENDA",
  "app.webcheckin": "CHECK-IN WEB",
  "menu.web_checkin": "CHECK-IN WEB",
  "app.webcheckin.DIRECTO": "Direto",
  "hotel.folio.guest.cedula_de_ciudadania": "Cédula de Cidadania",
  "hotel.folio.guest.pasaporte": "Passaporte",
  "hotel.folio.guest.tarjeta_de_identidad": "Cartão de Identidade",
  "hotel.folio.guest.tarjeta_de_extranjeria": "Cartão de Estrangeiro",
  "hotel.folio.guest.cedula_de_extranjeria": "Cédula de Estrangeiro",
  "hotel.folio.guest.male": "Masculino",
  "hotel.folio.guest.female": "Feminino",
  "hotel.maintenance": "Manutenção",
  "hotel.maintenance.start_date": "Data de Início",
  "hotel.maintenance.end_date": "Data de Fim",
  "hotel.maintenance.room": "Quarto",
  "hotel.maintenance.criticality": "Criticidade",
  "hotel.maintenance.issue": "Problema",
  "hotel.maintenance.confirm": "Confirmar",
  "hotel.maintenance.low": "Baixa",
  "hotel.maintenance.urgent": "Urgente",
  "hotel.maintenance.important": "Importante",
  "hotel.maintenance.total_days": "Total de Dias",
  finish: "FINALIZAR",
  webcheckin_success_msg:
    "Parabéns, agora seu check-in será muito mais rápido em nosso hotel, e a partir de agora você poderá aproveitar nossos serviços Premium.",
  webcheckin_success_header: "Registro Bem-Sucedido!!!",
  webcheckin_success_our_services: "Nossos Serviços",
  webcheckin_booking_page:
    "Agora você pode adicionar hóspedes a cada um de seus quartos reservados. Sempre que quiser adicionar uma pessoa, clique no quarto.",
  male: "Masculino",
  female: "Feminino",
  cedula_ciudadania: "Cédula de Cidadania",
  pasaporte: "Passaporte",
  tarjeta_identidad: "Carteira de Identidade",
  tarjeta_extranjeria: "Carteira de Identidade de Estrangeiro",
  cedula_extranjeria: "Cédula de Estrangeiro",
  adult: "Adulto",
  child: "Criança",
  type: "TIPO",
  link: "LINK",
  file: "ARQUIVO",
  "menu.charts": "Dashboard",
  sales: "Vendas",
  payroll: "Folha de Pagamento",
  hotel: "Hotel",
  crm: "CRM",
  purchases: "Compras",
  dashboard: "Dashboard",
  go_back: "VOLTAR",
  address: "ENDEREÇO",
  country_residence: "PAÍS DE RESIDÊNCIA",
  unit: "UNIDADE",
  company: "Empresa",
  user: "Usuário",
  password: "Senha",
  enter: "Entrar",
  "modal_msg.record_successful": "Registro inserido corretamente!",
  "modal_msg.record_warning": "Aviso!",
  "modal_msg.record_ask": "Pergunta",
  "modal_msg.record_error": "Erro de Registro",
  "crm.customer_service.addres": "Endereço",
  "crm.customer_service.search": "Buscar",
  "crm.customer_service.case": "Detalhe do Caso",
  "crm.customer_service.response": "Resposta",
  "crm.customer_service.description": "Resumo da Solicitação",
  "crm.customer_service.state": "Estado",
  "crm.customer_service.party": "Nome",
  "crm.customer_service.cs_date": "Data",
  "crm.customer_service.number": "Número do Registro",
  "crm.customer_service.party_id_number": "Número de Identificação",
  "crm.customer_service.draft": "Rascunho",
  "crm.customer_service.open": "Aberto",
  "crm.customer_service.close": "Fechado",
  "crm.customer_service.email": "Email",
  "crm.customer_service.attach_customer_1": "Anexo",
  "crm.customer_service.create_service": "CRIAR REGISTRO",
  "crm.customer_service.ethnical_group": "Grupo Étnico",
  "crm.customer_service.special_population": "População Especial",
  "crm.customer_service.personal_information": "Informações Pessoais",
  "crm.customer_service.pqrs_information": "Informações PQRS",
  "crm.customer_service.demographic_information":
    "Informações Sociodemográficas",
  "crm.customer_service.description_facts": "Descrição dos Fatos",
  "crm.customer_service.phone": "Telefone",
  "crm.customer_service.health_provider": "Prestador de Saúde",
  "crm.customer_service.detailed_especific_1": "Detalhe Específico",
  "form_modal.button_close": "FECHAR",

  button_open: "ABRIR",
  "board.dialog.button_close": "Fechar",
  "board.dialog.button_ok": "OK",
  "board.dialog.button_cancel": "Cancelar",
  "planner.date": "Data",
  "hotel.folio.meal_plan": "Plano de Refeição",
  "hotel.folio.pending_total": "Total Pendente",
  "hotel.folio.agent": "Agente",
  "hotel.folio.unit_price_w_tax": "Preço c/ Imp.",
  "hotel.folio.vehicle_plate": "Placa do Veículo",
  "hotel.folio.guests": "Hóspedes",
  "hotel.folio.payment_status": "Status do Pagamento",
  "hotel.folio.charge": "Cobranças",
  "hotel.folio.charge.description": "Descrição",
  "hotel.folio.charges": "Cobranças",
  "hotel.folio.guest": "Hóspede",
  "hotel.folio.guest.main_guest": "Hóspede Principal",
  "hotel.folio.guest.name": "Nome",
  "hotel.folio.guest.type_document": "Tipo de Documento",
  "hotel.folio.guest.id_number": "Número de Identidade",
  "hotel.folio.guest.mobile": "Celular",
  "hotel.folio.guest.email": "Email",
  "hotel.folio.guest.address": "Endereço",
  "hotel.folio.guest.nationality": "Nacionalidade",
  "hotel.folio.guest.origin_country": "País de Origem",
  "hotel.folio.guest.target_country": "País de Destino",
  "hotel.folio.guest.birthday": "Data de Nascimento",
  "hotel.folio.guest.notes": "Notas",
  "hotel.folio.guest.visa_date": "Data do Visto",
  "hotel.folio.guest.visa_number": "Número do Visto",
  "hotel.folio.guest.sex": "Sexo",
  "hotel.folio.guest.profession": "Profissão",
  "hotel.folio.guest.registro_civil": "Registro Civil de Nascimento",
  "hotel.folio.guest.tarjeta_identidad": "Cartão de Identidade",
  "hotel.folio.guest.cedula_ciudadania": "Cédula de Cidadania",
  "hotel.folio.guest.tarjeta_extranjeria": "Cartão de Estrangeiro",
  "hotel.folio.guest.cedula_extranjeria": "Cédula de Estrangeiro",
  "hotel.folio.guest.nit": "NIT",
  "hotel.folio.guest.add_guest": "Adicionar",
  "hotel.folio.guest.cancel": "Cancelar",
  "hotel.folio.guest.tipo_documento_extranjero":
    "Tipo de Documento Estrangeiro",
  "hotel.folio.guest.pep": "PEP",
  "hotel.folio.guest.nit_otro_pais": "NIT de Outro País",
  "hotel.folio.guest.nuip": "NUIP",
  "hotel.folio.guest.country": "País",
  "hotel.folio.guest.subdivision": "Subdivisão",
  "hotel.folio.guest.clone_holder": "Criar Hóspede",
  "hotel.folio.charge.sale_date": "Data",
  "hotel.folio.charge.product": "Produto",
  "hotel.folio.charge.quantity": "Quantidade",
  "hotel.folio.charge.unit_price_w_tax": "Preço Unitário c/ Imp.",
  "hotel.folio.charge.amount": "Valor",
  "hotel.folio.charge.status": "Status",
  "hotel.folio.charge.pending": "Pendente",
  "hotel.folio.charge.add_product": "Adicionar Produto",
  "app.webcheckin.customer": "CLIENTE",
  "app.webcheckin.no_booking": "Nº RESERVA",
  "app.webcheckin.channel": "CANAL",
  "app.webcheckin.arrival_date": "DATA DE CHEGADA",
  "app.webcheckin.departure_date": "DATA DE SAÍDA",
  "app.webcheckin.finish": "FINALIZAR",
  "app.webcheckin.direct": "DIRETO",
  "app.webcheckin.main_guest": "VOCÊ É O HÓSPEDE PRINCIPAL?",
  "app.webcheckin.name": "NOME",
  "app.webcheckin.mobile": "CELULAR",
  "app.webcheckin.email": "EMAIL",
  "app.webcheckin.address": "ENDEREÇO",
  "app.webcheckin.nationality": "NACIONALIDADE",
  "app.webcheckin.country_residence": "PAÍS DE RESIDÊNCIA",
  "app.webcheckin.sex": "SEXO",
  "app.webcheckin.type_guest": "TIPO DE HÓSPEDE",
  "app.webcheckin.id_number": "Nº DOCUMENTO",
  "app.webcheckin.type_document": "TIPO DE DOCUMENTO",
  "app.webcheckin.visa_number": "Nº VISTO",
  "app.webcheckin.visa_date": "DATA DE VALIDADE DO VISTO",
  "app.webcheckin.birthday": "DATA DE NASCIMENTO",
  "app.webcheckin.profession": "PROFISSÃO",
  "app.webcheckin.add_guest": "ADICIONAR HÓSPEDE",
  "app.webcheckin.cancel": "CANCELAR",

  "surveillance.location.code": "CÓDIGO",
  "surveillance.location.name": "NOME",
  "surveillance.location.customer": "CLIENTE",
  "surveillance.location.city": "CIDADE",

  "schedule.scheduling": "AGENDAMENTO",
  "surveillance.schedule.shift": "Turno",
  "surveillance.schedule.shift.guard": "Guarda",
  "surveillance.schedule.shift.location": "Local",
  "surveillance.schedule.shift.shift_date": "Data",
  "surveillance.schedule.shift.replicate": "Replicar",
  "surveillance.schedule.shift.extra_shift": "Turno Extra",
  "surveillance.schedule.shift.shift": "Tipo de Turno",
  "surveillance.schedule.shift.duration": "Duração",
  "surveillance.schedule.shift.enter_dtime": "Entrada",
  "surveillance.schedule.shift.exit_dtime": "Saída",
  "surveillance.schedule.shift.position": "Posição",
  "surveillance.schedule.shift.event_category": "Novedade Prog.",
  "surveillance.schedule.shift.event": "Novedade Efetiva",
  "surveillance.schedule.shift.notes": "Notas",
  "surveillance.schedule.shift.event_start_date": "Início da Novedade",
  "surveillance.schedule.shift.event_end_date": "Fim da Novedade",
  "surveillance.schedule.shift.kind": "Turno",
  "surveillance.schedule.shift.state": "Estado",
  "surveillance.schedule.shift.guard.photo_link": "Foto",
  "surveillance.schedule.shift.draft": "Rascunho",
  "surveillance.schedule.shift.performed": "Realizado",
  "surveillance.schedule.shift.schedule": "Agendamento",
  "surveillance.schedule.state": "Estado",
  "surveillance.schedule.draft": "Rascunho",
  "surveillance.schedule.planned": "Planejado",
  "schedule.shift": "TURNO",
  "schedule.search": "Buscar",
  "company.employee.party": "Funcionário",
  "company.employee.code": "Código",
  "modal.search": "BUSCAR",
  "surveillance.schedule.period": "Período",
  "surveillance.schedule.location": "Local",
  "crm.opportunity.state": "Estado",
  "crm.opportunity.agent": "Agente",
  "crm.opportunity.party_contact": "Contato",
  "crm.opportunity.party_category": "Categoria",
  "crm.opportunity.contact_phone": "Telefone",
  "crm.opportunity.state.lead": "Lead",
  "crm.opportunity.state.opportunity": "Oportunidade",
  "crm.opportunity.city": "Cidade",
  "crm.opportunity.conversion_probability": "Probabilidade de Conversão",
  "crm.opportunity.lead_origin": "Origem",
  "crm.opportunity.amount": "Valor",
  "crm.opportunity.type": "Tipo",
  "crm.opportunity.prospect": "Prospecto",
  "crm.opportunity.end_date": "Data Final",
  "crm.opportunity.line.payment_term": "Termo de Pagamento",
  "crm.opportunity.line.description": "Descrição",
  "crm.opportunity.line.billing_frecuency": "Faturamento",
  "crm.opportunity.line.unit": "Unidade",
  "crm.opportunity.line.availability": "Disponibilidade",
  "crm.opportunity.brochure": "Brochura",
  "crm.opportunity.company": "Empresa",
  "crm.opportunity.contact_email": "Email do Contato",
  "crm.opportunity.more_probabilty": "Maior Probabilidade",
  "crm.opportunity.last_90": "Últimos 90 dias",
  "crm.opportunity.last_quotations": "Últimas Cotações",
  "crm.opportunity.panel.win_rate": "Taxa de Sucesso",
  "crm.opportunity.panel.win_rate_today": "Hoje",
  "crm.opportunity.panel.win_rate_yesterday": "Ontem",
  "crm.opportunity.panel.activities_today": "Ativ. Hoje",
  "crm.opportunity.panel.activities_tomorrow": "Ativ. Amanhã",
  "crm.opportunity.panel.activities_pending": "Ativ. Pendentes",
  "crm.opportunity.panel.leads": "Leads",
  "crm.opportunity.panel.leads_draft": "Rascunho",
  "crm.opportunity.panel.leads_convert": "Converter",
  "crm.opportunity.sales.sale_date": "Data da Venda",
  "crm.prospect.name": "Nome",
  "crm.prospect.phone": "Telefone",
  "crm.prospect.email": "Email",
  "crm.prospect.agent": "Agente",
  "modal_form.button_accept": "Aceitar",
  "modal_form.button_add": "Adicionar",
  "modal_form.button_save": "Salvar",
  "board.button_field_create": "Criar",
  "board.button_field_edit": "Editar",
  "party.party.id_number": "Nº Documento",
  "party.party.type_document": "Tipo de Documento",
  "party.party.nationality": "Nacionalidade",
  "party.party.main_email": "Email",
  "party.party.main_mobile": "Celular",
  "party.party.phone": "Telefone",
  "party.party.sex": "Sexo",
  "party.party.birthday": "Data de Nascimento",
  "party.party": "Adicionar Cliente",
  "party.party.street": "Rua",
  "party.party.account_receivable": "Conta a Receber",
  "party.party.country": "País",
  "party.party.subdivision": "Subdivisão",
  "party.party.city": "Cidade",
  holder: "Titular",
  holder_guest: "Titular / Hóspede",
  guest: "Hóspede",
  no_breakfast: "Sem Café",
  all_inclusive: "Tudo Incluído",
  bed_breakfast: "Cama e Café",
  full_american: "Café Americano Completo",
  half_american: "Café Americano Parcial",
  "menu.activity": "Atividades",
  "sale_activity.activity.time_start": "Início",
  "sale_activity.activity.time_end": "Fim",
  "sale_activity.activity.available": "Disponível",
  "sale_activity.activity.quota": "Cota",
  "sale_activity.activity.state": "Estado",
  "sale_activity.activity.add": "Adicionar",
  "sale_activity.activity.employee": "Funcionário",
  "sale.sale.add_courtesy": "Adicionar Cortesia",
  all: "Todos",
  partial: "Parcial",
  personal_information: "Informações Pessoais",
  "rental.booking.number": "Número",
  "rental.booking.equipment": "Equipamento",
  "rental.booking.type_document": "Tipo de Documento",
  "rental.booking.doc_number": "Número do Documento",
  "rental.booking.booking_date": "Data",
  "rental.booking.first_name": "Nome",
  "rental.booking.last_name": "Sobrenome",
  "rental.booking.mobile": "Celular",
  "rental.booking.state": "Estado",
  "rental.booking.draft": "Rascunho",
  "rental.booking.booking": "Reserva",
  "rental.booking.processed": "Processado",
  "rental.booking.cancelled": "Cancelado",
  "rental.booking": "Reserva de Aluguel",
  "rental.booking.company": "Empresa",
  "rental.service": "Serviço de Venda",
  "rental.service.number": "Número",
  "rental.service.product": "Produto",
  "rental.service.booking": "Reserva",
  "rental.service.start_date": "Data de Início",
  "rental.booking.party": "Cliente",
  "rental.booking.product": "Produto",
  "rental.booking.send_sms": "ENVIAR SMS",
  "rental.booking.email": "Email",
  "rental.booking.address": "Endereço",
  "rental.booking.zip": "CEP",
  "rental.booking.subdivision": "Estado",
  "rental.booking.suburb": "Bairro",
  "rental.booking.city": "Cidade",
  "rental.booking.post_code": "CEP",
  "rental.booking.start_date": "Data de Início",
  "rental.booking.end_date": "Data Final",
  "rental.booking.lapse_time": "Semanas",
  "menu.rental": "SERVIÇO DE ALUGUEL",
  "menu.rentalb": "RESERVAS",
  "rental.booking.process": "Processar",
  "rental.booking.add_booking": "Adicionar Reserva",
  "rental.booking.notification_pickup": "Notificação de Retirada",
  "rental.booking.comment": "Comentário",
  driver_license: "Carteira de Motorista",
  passport: "Passaporte",
  medicare_card: "Cartão Medicare",
  phone: "Telefone",
  fax: "Fax",
  email: "Email",
  chat: "Chat",
  walking: "A Pé",
  web: "Web",
  channel_manager: "Gestor de Canais",
  ota: "OTA",
  information_card: "Informações do Cartão",
  not_information_card: "Você não possui cartões cadastrados",
  "web.user.card_number": "Número do Cartão",
  "web.user.holder_name": "Nome do Titular",
  "web.user.name": "Nome",
  "web.user.brand": "Tipo",
  "web.user.state": "Estado",
  "web.user.active": "Ativar",
  "web.user.deactive": "Desativar",
  "portal_customer.add_card": "Adicionar Cartão",
  "portal_customer.holder_name": "Nome do Titular",
  "portal_customer.card_number": "Número do Cartão",
  "portal_customer.expiration_date": "Data de Validade",
  "portal_customer.secret_code": "Código de Segurança",
  invalid_card_number: "Número do cartão inválido",
  invalid_cvc: "Código de segurança inválido",
  invalid_expire_date: "Data de validade inválida",
  invalid_cvc_card_number: "Número do cartão ou CVC inválido",
  card_validated: "Cartão válido, deseja registrá-lo?",
  button_confirm: "Confirmar",
  button_accept: "Aceitar",
  validation_card_openpay: "Validação do Cartão",
  confirm_card_openpay: "Confirmação de Registro do Cartão",
  "activity.widget_side_status.revenue_today": "Porcentagem de Vendas",
  "sale_activity.activity.quantity": "Quantidade",
  "sale.sale.pay_method": "FATURAR",
  "sale.sale.payment_term": "Prazo de Pagamento",
  "rental.service.appbooking": "ENVIAR RESERVA",
  "rental.booking.week": "Semanas",
  "sale.line.base_price": "Preço Base",
  "sale.sale.add_discount": "Adicionar Desconto",
  "sale.sale.paid_amount": "Pago",
  "sale.sale.residual_amount": "Pendente",
  "rental.booking.add_signature": "Adicionar Assinatura",
  "rental.booking.send_confirmation_email": "Reenviar Confirmação",
  "rest_order.options": "Opções",
  "surveillance.schedule_month.report.period": "Período",
  "surveillance.schedule_month.report.location": "Local",
  "surveillance.schedule_month.report": "Relatório de Conformidade",
  "schedule.compliance_report": "RELATÓRIO DE CONFORMIDADE",
  "schedule.guards_report": "RELATÓRIO DE GUARDAS",
  "rental.service.add_signature": "Criar Serviço",
  "maintenance.equipment.state": "Estado",
  "maintenance.equipment.excellent": "Excelente",
  "maintenance.equipment.good": "Bom",
  "maintenance.equipment.acceptable": "Aceitável",
  "maintenance.equipment.bad": "Ruim",
  "maintenance.equipment.product": "Produto",
  "maintenance.equipment.active": "Ativo",
  "maintenance.equipment.gps_serial": "Serial do GPS",
  "maintenance.equipment.serial": "Serial",
  "maintenance.equipment.vin": "VIN",
  "maintenance.equipment.model_num": "Número do Modelo",
  "maintenance.equipment.available": "Disponível",
  "maintenance.equipment.maintenance": "Manutenção",
  "maintenance.equipment.not_available": "Indisponível",
  "maintenance.equipment.stolen": "Roubado",
  "maintenance.equipment.status": "Estado",
  "maintenance.equipment": "EQUIPAMENTOS E INSTRUMENTOS",
  "menu.maintenance": "EQUIPAMENTOS E INSTRUMENTOS",
  "menu.attendance_control": "CONTROLE DE ACESSO",
  "rental.service.party": "Cliente",
  "rental.service.id_number": "Número",
  "rental.service.email": "Email",
  "rental.service.mobile": "Celular",
  "rental.service.end_date": "Data Final",
  "rental.service.equipment": "Equipamento",
  "rental.service.state": "Estado",
  "rental.service.draft": "Rascunho",
  "rental.service.processed": "Processado",
  "rental.service.confirmed": "Confirmado",
  "rental.service.product_check_list": "LISTA DE VERIFICAÇÃO DO PRODUTO",
  "rental.service.product_check_list.item": "Item",
  "rental.service.product_check_list.state_delivery": "Estado Inicial",
  "rental.service.product_check_list.state_return": "Verificação na Devolução",
  "rental.service.service_date": "Data do Serviço",
  "rental.service.bank_account_number": "Número da Conta Bancária",
  "rental.service.bank_bsb": "Código BSB",
  "rental.service.hiring_time": "Semanas",
  "rental.service.issues_presented": "Descrição de Problemas",
  "rental.service.odometer_start": "Odômetro Inicial",
  "rental.service.photo_link_party_id": "FOTO ID DO CLIENTE",
  "rental.service.photo_link_agree": "FOTO DE CONCORDÂNCIA",
  "rental.service.cover_prices": "Cobertura de Preços",
  "rental.service.odometer_end": "Odômetro na Devolução",
  "rental.service.part_missing":
    "Problemas Conhecidos - Peças Faltando / Quebradas",
  "rental.service.confirm": "Confirmar",
  "rental.service.renewed": "Renovado",
  "rental.service.cancelled": "Cancelado",
  "rental.service.done": "Concluído",
  monthly: "Mensal",
  one_payment: "Pagamento Único",
  bimonthly: "Pagamento Único",
  biannual: "Semestral",
  annual: "Anual",
  "crm.customer_service": "Formulário de Registro",
  "activity.folio.charges.title":
    "Selecione o quarto onde deseja adicionar os encargos da atividade",
  "sale.sale.confirmed": "Confirmado",
  "sale.sale.party.mobile": "Celular",
  "sale.sale.party.name": "Cliente",
  "party.addresses": "Endereços",
  "party.addresses.street": "Rua",
  "party.addresses.country_code": "País",
  "party.addresses.department_code": "Estado / Departamento",
  "party.addresses.city_code": "Cidade",
  "party.contact_mechanisms": "Meios de Contato",
  "party.contact_mechanisms.type": "Tipo",
  "party.contact_mechanisms.name": "Nome",
  "party.contact_mechanisms.value": "Contato",
  "sale.sale.party.id_number": "N° Documento",
  "sale.sale.reference": "Referência",
  "menu.catalog": "CATÁLOGO",
  "date_range.select": "Selecionar",
  "date_range.filter_date": "Data para filtrar",
  "sale.sale.month": "Mês",
  "sale.sale.month_3": "3 Meses",
  "sale.sale.month_6": "6 Meses",
  "app.booking.name": "Nome",
  "app.booking.lastname": "Sobrenome",
  "app.booking.add_pay": "Adicionar Pagamento",
  "app.booking.sex": "Gênero",
  "app.booking.type_document": "Tipo de Documento",
  "app.booking.id_number": "N° Documento",
  "app.booking.mobile": "Telefone",
  "app.booking.email": "Email",
  "app.booking.address": "Endereço",
  "app.booking.btn-form": "RESERVAR",
  "app.booking.btn-form-payment": "IR PARA PAGAR",
  "app.booking.country": "País",
  "app.booking.department": "Estado / Departamento",
  "app.booking.city": "Cidade",
  "app.booking.btn_add_coupon": "Adicionar Cupom",
  "sale.line.origin.time_start": "Início",
  "sale.line.origin.time_end": "Fim",
  "hotel.folio.charge.origin.time_start": "Início",
  "hotel.folio.charge.origin.time_end": "Fim",
  "sale.sale.printBrowser": "Imprimir",
  "hotel.folio.main_guest.id_number": "Identificação",
  "sale.sale.folios": "Transferir para Folio",
  "hotel.folio.room.code": "Quarto",
  "hotel.folio.add": "Adicionar",
  "sale.line.add_discount": "Aplicar Desconto",
  "sale.sale.transferred": "Transferido",
  "sale.sale.add_new": "Novo",
  "sale.sale.add": "Transferir",
  "sale_activity.add_customer": "Adicionar Cliente",
  agent: "Agente",
  news: "Novos",
  leads: "Iniciativa",
  opportunity: "Oportunidade",
  won: "Ganhos",
  lost: "Perdidos",
  cancelled: "Cancelado",
  amount: "Valor Negociado",
  success_rate: "Taxa de Sucesso",
  "menu.activity_information": "INFORMAÇÕES DE ATIVIDADES",
  "menu.supplies": "EQUIPE & SUPRIMENTOS",
  "menu.inventory2": "INVENTÁRIO & ESTOQUE",
  "menu.products": "PRODUTOS",
  "sale.sale.sale_device": "Terminal de Vendas",
  "sale_activity.activity.sale": "Vendidos",
  "sale.sale.create_uid": "Vendido por",
  "sale.sale.transferred_events": "Transferir para Evento",
  product: "Produto",
  accomodation: "Acomodação",
  "sale.line.invoice_lines.quantity": "Qtd. Faturada",
  "account.invoice": "Fatura",
  "account.invoice.line": "Produtos",
  "account.invoice.invoice_date": "Data da Fatura",
  "account.invoice.state": "Estado",
  "account.invoice.number": "Número",
  "account.invoice.party": "Terceiro",
  "account.invoice.description": "Descrição",
  "account.invoice.total_amount": "Total",
  "account.invoice.amount_to_pay": "A Pagar",
  "account.invoice.posted": "Contabilizado",
  "account.invoice.paid": "Pago",
  "account.invoice.validated": "Validado",
  "account.invoice.cancelled": "Cancelado",
  "account.invoice.draft": "Rascunho",
  "account.invoice.untaxed_amount": "Base",
  "account.invoice.line.product": "Produto",
  "account.invoice.line.unit": "Unidade",
  "account.invoice.line.quantity": "Quantidade",
  "account.invoice.line.unit_price": "Preço Unitário",
  "account.invoice.line.amount": "Valor",
  "sale.line.moves.quantity": "Qtd. Enviada",
  "stock.shipment.out.number": "Número",
  "stock.move.state": "Estado",
  "stock.move.done": "Finalizado",
  "stock.move.waiting": "Aguardando",
  "stock.move.draft": "Rascunho",
  "stock.shipment.out.return.contact_address": "Endereço do Cliente",
  "stock.shipment.out.return.delivery_address": "Endereço de Entrega",
  "stock.shipment.out.return.confirm": "Salvar como Rascunho",
  "stock.shipment.out.reference": "Referência",
  "stock.shipment.out.effective_date": "Data Efetiva",
  "stock.shipment.out.planned_date": "Data Programada",
  "stock.shipment.out.state": "Estado",
  "stock.shipment.out.done": "Finalizado",
  "stock.shipment.out.waiting": "Aguardando",
  "stock.shipment.out.cancelled": "Cancelado",
  "stock.shipment.out.draft": "Rascunho",
  "stock.shipment.out.warehouse_storage": "Depósito",
  "stock.shipment.out.return.number": "Número",
  "stock.shipment.out.return.reference": "Referência",
  "stock.shipment.out.return.effective_date": "Data Efetiva",
  "stock.shipment.out.return.planned_date": "Data Programada",
  "stock.shipment.out.return.state": "Estado",
  "stock.shipment.out.return.warehouse_storage": "Depósito",
  "stock.shipment.out.return.done": "Finalizado",
  "stock.shipment.out.return.waiting": "Aguardando",
  "stock.shipment.out.return.cancelled": "Cancelado",
  "stock.shipment.out.customer": "Cliente",
  "stock.shipment.out.warehouse": "Armazém",
  "stock.shipment.out.receive": "Reservar",
  "sale.sale.none": "Pendente",
  "sale.sale.pending": "Pendente",
  "sale.sale.exception": "Exceção",
  "sale.sale.canceled": "Cancelado",
  "sale.sale.shipments": "Envios",
  "sale.sale.shipment_returns": "Devoluções",
  "sale.sale.value_invoiced": "Valor Faturado",
  "sale.sale.value_to_invoiced": "Valor a Faturar",
  "sale.sale.invoices": "Faturas",
  "menu.sale_audit": "AUDITORIA DE VENDAS",
  "crm.person": "Acompanhantes",
  "crm.person.name": "Nome",
  "crm.person.id_number": "N° ID",
  "crm.person.phone": "Telefone",
  "crm.person.email": "Email",
  "sale.line.person": "Acompanhantes",
  "sale.line.person.name": "Nome",
  "sale.line.person.id_number": "N° ID",
  "sale.line.person.phone": "Telefone",
  "sale.line.person.email": "Email",
  "sale.line.person.arrival_date": "Data de Chegada",
  "sale.line.person.today": "Hoje",
  "sale.line.person.month": "Mês",
  "sale.line.person.week": "Semana",
  "sale.line.person.line": "Serviço",
  "sale.line.person.sale": "Venda",
  "sale.lines.add_tags": "Adicionar Etiquetas",
  "sale.line.tag": "Etiquetas",
  "web.booking.avalaible": "Disponíveis",
  "web.booking.occupation": "Ocupação Máx.",
  "web.booking.minimum_stay": "Estadia Mínima",
  "app.booking.msg_nodata": "Não há quartos disponíveis",
  "app.booking.msg_minimum_stay":
    "Para as datas solicitadas, é necessário um mínimo de {nights} noites de estadia.",
  "app.booking.msg_nodate": "Selecione Check-In e Check-Out",
  "app.booking.breakfast": "Café da Manhã",
  "menu.account_statement": "EXTRATO DE CONTA",
  "account.statement": "Extratos de Conta",
  "account.statement.name": "Nome",
  "account.statement.journal": "Meio de Pagamento",
  "account.statement.sale_device": "Terminal",
  "account.statement.end_balance": "Saldo Final",
  "account.statement.start_balance": "Saldo Inicial",
  "account.statement.turn": "Turno",
  "account.statement.state": "Estado",
  "account.statement.draft": "Rascunho",
  "account.statement.validated": "Validado",
  "account.statement.posted": "Contabilizado",
  "account.statement.reports": "Relatórios",
  "account.statement.select_device": "Selecione terminal de vendas",
  "web.booking.txt_iva": "Taxas e impostos não incluídos",
  "app.booking.term_cond": "Termos e Condições",
  "sale_pos.money_count.bill": "Moeda / Cédula",
  "sale_pos.money_count.quantity": "Quantidade",
  "sale_pos.money_count.amount": "Valor",
  "sale_pos.money_count.total": "Total",
  "app.booking.privacy": "Política de Privacidade",
  "app.booking.redirect": "Você está sendo redirecionado para o pagamento",
  "app.booking.label_form": "Adicione os dados do titular",
  "app.booking.label_aside": "Sua Reserva",
  "app.booking.btn_confirm": "CONFIRMAR",
  "app.booking.amount": "Total da reserva",
  "app.booking.right_reserved": "Todos os direitos reservados",
  "app.booking.copyright": "Presik Copyright © 2026",
  "app.booking.validate_email": "Valide seu e-mail",
  "app.booking.create_reserve": "Reserva criada",
  "app.booking.successfully": "com sucesso",
  "app.booking.alert_filter_date":
    "Selecione uma data de check-out posterior à data de check-in.",
  "app.booking.alert_select_room":
    "Selecione um tipo de quarto para sua reserva.",
  "app.booking.date_payment": "Data de pagamento",
  "app.booking.night": "Noite",
  "app.booking.price": "Tarifa",
  "app.booking.includes": "Inclui",
  "app.booking.btn_reserve_item": "Adicionar à reserva",
  "app.booking.note": "Nota",
  "app.booking.note_placeholder":
    "Caro hóspede, escreva suas solicitações especiais.",
  "sale_pos.money_count": "Contagem de Dinheiro",
  "ticket_system.ticket.status": "Status",
  "ticket_system.ticket.waiting": "Aguardando",
  "ticket_system.ticket.done": "Finalizado",
  "ticket_system.ticket.busy": "Ocupado",
  "ticket_system.ticket.cancelled": "Cancelado",
  "ticket_system.ticket.turn": "# Turno",
  "ticket_system.ticket.number_id": "# Documento",
  "ticket_system.ticket.position.number": "Posição",
  "ticket_system.ticket.state": "Estado",
  "ticket_system.ticke_not_found": "Não há turnos no estado de espera.",
  "ticket_system.ticket.add_turn": "Você deve se atribuir um turno",
  "ticket_system.ticket.next_turn": "PRÓXIMO TURNO",
  "ticket_system.ticket.take_turn": "PEGAR TURNO",
  "ticket_system.ticket.finish_turn": "FINALIZAR TURNO",
  "ticket_system.ticket.currents_turn": "Módulo",
  "ticket_system.ticket.attention_schedule": "Horário de atendimento",
  "ticket_system.ticket.weekday": "Seg - Sex",
  "ticket_system.ticket.wekend": "Sáb - Dom",
  "sale.gift.first_name": "Nome",
  "sale.gift.search_order": "Buscar número do pedido",
  "sale.gift.last_name": "Sobrenome",
  "sale.gift.phone": "Telefone",
  "sale.gift.email": "E-mail",
  "sale.gift.from": "De",
  "sale.gift.to": "Para",
  "sale.gift.phone_gift": "Telefone",
  "sale.gift.message_gift": "Nota",
  "sale.gift.address_gift": "Endereço",
  "sale.gift.receive": "Quem recebe?",
  "hotel.calendar.add_booking": "Reserva",
  "hotel.calendar.add_maintenance": "Manutenção",
  "hotel.guest.you_can_not_clone_holder":
    "Não é possível criar automaticamente um hóspede se o titular ainda não foi criado",
  "account_statement_co.advanced_report": "Extrato Avançado",
  "account_statement_co.advanced": "Extrato Avançado",
  "account_statement_co.advanced.description":
    "Relatório de extratos globais incluindo todos os ambientes / lojas",
  "account_statement_co.advanced.start.operation_center": "Centro de Operações",
  "account_statement_co.advanced.start.date": "Data",
  "account_statement_co.cash_up_report": "Fechamento de Caixa",
  "account_statement_co.cash_up": "Fechamento de Caixa",
  "account_statement_co.cash_up.description":
    "Relatório de fechamento de caixa individual (por usuário)",
  "account_statement_co.cash_up.start.operation_center": "Centro de Operações",
  "account_statement_co.cash_up.start.date": "Data",
  "account_statement_co.cash_up.start.shop": "Loja / Ambiente",
  "account_statement_co.cash_up.start.user": "Usuário",
  "hotel.calendar.select_date": "Selecionar Data",
  "attendance_control.start": "INICIAR",
  "attendance_control.cancel": "CANCELAR",
  "attendance_control.income": "ENTRADA",
  "attendance_control.start_break": "INÍCIO DO INTERVALO",
  "attendance_control.end_break": "FIM DO INTERVALO",
  "attendance_control.output": "SAÍDA",
  "attendance_control.attendance": "PRESENÇA",
  "attendance_control.control": "CONTROLE DE",
  "attendance_control.face_recognition": "RECONHECIMENTO FACIAL",
  "attendance_control.warning_step2":
    "Lembre-se de que ao inserir o código, uma foto será capturada",
  "attendance_control.verified_user": "USUÁRIO VERIFICADO",
  "attendance_control.position": "Cargo",
  "attendance_control.you_have": "Você tem",
  "attendance_control.warning_recognition":
    "segundos para se identificar e realizar uma ação.",
  "attendance_control.idle":
    "Por favor, olhe para a câmera para que você possa ser identificado.",
  "attendance_control.not_recognized": "Usuário não reconhecido!",
  "attendance_control.detecting": "Um momento, analisando o rosto.",
  "attendance_control.error_recognized":
    "Ops, ocorreu um erro durante o reconhecimento, tente novamente.",
  "menu.qr_sale": "QR VENDAS",
  "stock.shipment.out.return.customer": "Cliente",
  "stock.shipment.out.return.warehouse": "Localização",
  "stock.shipment.out.return": "COLETA",
  "stock.shipment.out.return.receive": "Receber",
  "stock.shipment.out.return.print": "Imprimir",
  "electronic.payment.succeeded": "Pagamento realizado com sucesso",
  "electronic.payment.failed": "Seu pagamento não pôde ser processado",
  "electronic.payment.processing": "Seu pagamento está sendo processado",
  "electronic.payment.approved": "Seu pagamento foi aprovado",
  "electronic.payment.draft": "Pagamento em rascunho",
  "electronic.payment.openpay.customer": "Cliente Openpay",
  "electronic.payment.autocore.account": "Conta Autocore",
  "electronic.payment.paypal.account": "Conta Paypal",
  "electronic.payment.epayco.account": "Conta Epayco",
  add_header_modal: "Adicionar",
  actions: "Ações",
  reports: "Relatórios",
  "hotel.folio": "Fólios",
  "hotel.booking.wiz_payment.button_pay": "Pagar",
  "hotel.booking.wiz_payment.voucher": "Comprovante",
  "hotel.booking.wiz_payment.statement": "Forma de Pagamento",
  "hotel.booking.wiz_payment.amount": "Valor",
  "hotel.booking.wiz_payment.notes": "Notas",
  "hotel.booking.bill.add_guest": "Adicionar Hóspede",
  "stock.shipment.internal.print": "Imprimir",
  "app.sale.validation.alert_msg_success":
    "As receitas foram registradas com sucesso!",
  "stock.shipment.internal.barcode_validate": "VALIDAR ENTRADAS",
  "stock.shipment.internal.quantity": "Quantidade",
  "booking.widget.screen.view_more": "Ver mais",
  "hotel.folio.guest.transfer": "Transporte",
  "hotel.folio.guest.notes_transfer": "Notas de Transporte",
  "hotel.folio.guest.cradle": "Berço",
  "hotel.folio.guest.notes_cradle": "Notas do Berço",
  "hotel.folio.guest.pet": "Animal de Estimação",
  "hotel.folio.guest.notes_pet": "Notas do Animal",
};

const _pt = { ...pt, ...views_pt };

export default _pt;
